import React from "react";
import withTooltip from "../../ui_elements/withTooltip";
import { Tooltip } from "../../ui_elements/tooltip";
import Isvg from "../../../../vendor/react-inlinesvg";

class MarkdownButton extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.props.removeTooltip();
    }
  }

  render() {
    return (
      <button
        aria-expanded={this.props.ariaExpanded}
        className={this.props.className}
        onClick={this.props.onClick}
        data-tooltip={this.props.dataTooltip}
        data-tooltip-location="Bottom"
        onMouseEnter={!this.props.open && this.props.addTooltip}
        onMouseLeave={!this.props.open && this.props.removeTooltip}
      >
        <Isvg src={"/img/" + this.props.img + ".svg"} />
        <Tooltip tooltip={this.props.tooltip} />
        <span className="offScreen">{this.props.dataTooltip}</span>
      </button>
    );
  }
}

export default withTooltip(MarkdownButton);

MarkdownButton.defaultProps = {
  className: "noButton",
  onClick: () => {}
};
